import { type FC } from "react";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { Flex, Skeleton } from "@chakra-ui/react";
import { PromotionCodeForm } from "@/components/fragments/argyle/promotion-code-form/PromotionCodeForm";
import { type PlanData, PlanDataTable } from "@/components/fragments/argyle/plan-data-table";
import { planFormSkeletonTestId, planFormTestId, planFormTitleTestId } from "./const";
import { isNonNullable } from "@/modules/utils/predicate";
import { toranaCreditCardUrl } from "@/configs/externalUrls";

interface PlanFormProps {
  readonly planData: PlanData | null | undefined;
  readonly planDataLoading: boolean;
  readonly isLoaded: boolean;
  readonly promotionCode: string | undefined;
  readonly promotionCodeLoading: boolean;
  readonly showPromotionCodeForm: boolean;
}

export const PlanForm: FC<PlanFormProps> = ({
  planData,
  isLoaded,
  promotionCode,
  promotionCodeLoading,
  showPromotionCodeForm,
}) => {
  return (
    <Flex flexDir="column" gridGap="8" data-testid={planFormTestId}>
      <Box wordBreak="break-word" textAlign="center">
        <Typography variant="display3" data-testid={planFormTitleTestId}>
          お申込み中の商品
        </Typography>
        <Typography variant="display7" textAlign="center" color="secondary.main" pt="2" pb="8">
          ※ 決済はクレジットカードのみとなります
          <br />※ クレジットカードをお持ちでない方は
          <a href={toranaCreditCardUrl} target="_blank" rel="noreferrer">
            こちら
          </a>
          をご確認ください
        </Typography>
        <div id="campaign-announce-area" />
      </Box>
      <Flex flexDir="column" gridGap="1.5rem">
        {isLoaded && isNonNullable(planData) ? (
          <>
            <PlanDataTable data={planData} promotionCode={promotionCode} />
            {showPromotionCodeForm && <PromotionCodeForm promotionCodeLoading={promotionCodeLoading} />}
          </>
        ) : (
          <Skeleton height="48" data-testid={planFormSkeletonTestId} />
        )}
      </Flex>
    </Flex>
  );
};
